import React, { } from 'react';
import { Link, Breadcrumbs as MuiBreadcrumbs } from '@material-ui/core';
import { Link as CoreLink } from '@backstage/core-components';














export function Breadcrumbs({ items }) {
  return (
    React.createElement(MuiBreadcrumbs, null
      , items.map(({ text, href, iconPosition, icon }, index) => {
        const isLastIndex = index === items.length - 1;
        let underline = 'always';
        let style = {};
        if (isLastIndex) {
          underline = 'none';
          style = {
            fontStyle: 'italic',
          };
        }

        return (
          React.createElement(Link, {
            key: index,
            style: style,
            underline: underline,
            variant: "caption",
            component: CoreLink,
            to: href || '',}
          
            , (iconPosition === 'left' || iconPosition === undefined) && icon
            , text
            , iconPosition === 'right' && icon
          )
        );
      })
    )
  );
}
